import { createSelector } from 'reselect';

const selectCollectionPoints = (state: any) => state.collectionPoints;


export const selectCollectionPointsCurrentItem = createSelector([selectCollectionPoints], (collectionPoints) => collectionPoints.current);

export const selectCollectionPointsListItems = createSelector([selectCollectionPoints], (collectionPoints) => collectionPoints.list);

export const selectCollectionPointsItemById = (itemId: any) =>
    createSelector(selectCollectionPointsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCollectionPointsQueryItems = createSelector([selectCollectionPoints], (collectionPoints) => collectionPoints.query);

export const selectCollectionPointsCreatedItem = createSelector([selectCollectionPoints], (collectionPoints) => collectionPoints.create);

export const selectCollectionPointsUpdatedItem = createSelector([selectCollectionPoints], (collectionPoints) => collectionPoints.update);

export const selectCollectionPointsReadItem = createSelector([selectCollectionPoints], (collectionPoints) => collectionPoints.read);

export const selectCollectionPointsDeletedItem = createSelector([selectCollectionPoints], (collectionPoints) => collectionPoints.delete);

export const selectCollectionPointsSearchedItems = createSelector([selectCollectionPoints], (collectionPoints) => collectionPoints.search);

export const selectCollectionPointsItemsCount = createSelector([selectCollectionPoints], (collectionPoints) => collectionPoints.count);

export const selectCollectionPointsItemsFilter = createSelector([selectCollectionPoints], (collectionPoints) => collectionPoints.filter);